<template>
  <div class="flex justify-center items-center w-inherit -mt-10 relative z-10">
    <div class="flex flex-col justify-center items-center w-full md:mx-2">
      <transition name="fade" mode="out-in">
        <div class="w-full" v-if="loading">
          <channel-loading-item></channel-loading-item>
          <channel-loading-item></channel-loading-item>
          <channel-loading-item></channel-loading-item>
          <channel-loading-item></channel-loading-item>
          <channel-loading-item></channel-loading-item>
          <channel-loading-item></channel-loading-item>
        </div>
        <div class="w-full" v-else>
          <div class="w-full" v-for="(category, index) in categories" :key="category.slug">
            <h3
              class="text-grey-6 text-lg font-semibold uppercase border-b-2 border-blue-6 mb-2 pl-2 xl:pl-0"
              v-if="index !== 0"
            >{{ category.name }}</h3>
            <channel-item
              :key="channel.slug"
              v-for="channel in category.channels"
              :channel="channel"
              :category="category"
            />
          </div>
        </div>
      </transition>
    </div>
    <portal to="banner-portal">
      <div class="w-full relative">
        <img v-if="isMobile" src="@/assets/home_hero.png" class="w-full h-full object-cover absolute z-0 md:rounded-l-lg" />
        <video
          v-else
          poster="@/assets/home_hero.png"
          playsinline
          autoplay
          muted
          loop
          class="w-full h-full object-cover absolute z-0 md:rounded-l-lg"
        >
          <source :src="hero" type="video/webm" />
          <source src="@/assets/home_hero.mp4" type="video/mp4" />
        </video>
        <div class="w-full h-full absolute z-10 bg-grey-0 opacity-75 md:rounded-l-lg"></div>
        <transition name="fade">
          <div
            class="w-full h-full absolute z-20 flex flex-col items-center justify-center"
            v-if="!loading"
          >
            <div class="text-sm uppercase">
              <span class="inline-block text-blue-7 font-bold mr-1">{{ users.length }}</span>
              <span
                class="inline-block font-semibold text-grey-7"
              >Currently Active User{{ users.length !== 1 ? 's' : '' }}</span>
            </div>
            <div class="text-sm text-grey-8 text-center px-2 max-w-lg" v-if="users.length">{{ usernames }}</div>
          </div>
        </transition>
      </div>
    </portal>
  </div>
</template>

<script>
import ChannelItem from "@/components/Items/ChannelItem"
import ChannelLoadingItem from "@/components/Items/Loading/ChannelLoadingItem"
import { mapActions, mapGetters } from "vuex"
import { EventBus } from "@/events"
import { map, filter } from "lodash"
import { isMobile } from 'mobile-device-detect';

export default {
  name: "ChannelList",
  components: {
    ChannelItem,
    ChannelLoadingItem
  },
  data() {
    return {
      users: null,
      width: 0
    }
  },
  watch: {
    $route: {
      handler() {
        this.fetch()
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      categories: "categories/list"
    }),
    loading() {
      return this.users === null || this.categories === null
    },
    usernames() {
      let x = 0
      let users = map(
        filter(this.users, function() {
          x++
          return x <= 10
        }),
        function(item) {
          return item.username
        }
      ).join(", ")

      if (this.users.length > 10)
        users = users + " and " + (this.users.length - 10) + " more.."

      return users
    },
    hero() {
      if(this.width > 800) {
        return require('@/assets/home_hero-1200.webm')
      }else if(this.width > 600) {
        return require('@/assets/home_hero-800.webm')
      }
      return require('@/assets/home_hero-600.webm')
    },
    isMobile() {
      return isMobile
    }
  },
  methods: {
    ...mapActions({
      fetchCategories: "categories/fetch"
    }),
    async fetch() {
      await this.$api.users
        .active()
        .then(response => (this.users = response.data))
      this.fetchCategories()
    },
    handleResize() {
      this.width = window.innerWidth;
    }
  },
  mounted() {
    EventBus.$on("auth:login", () => this.fetch())
    EventBus.$on("auth:logout", () => this.fetch())

    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  beforeDestroy() {
    EventBus.$off("auth:login")
    EventBus.$off("auth:logout")

    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
